import {ProgressBar} from "react-bootstrap";
import React from "react";
const ProgressBarUplaod = (props) => {
    const failed = props.failed || {};
    return (
        <ul>
            {props.data.map((file, index) => {
                const failReason = failed[file.name];
                const isFailed = Boolean(failReason);
                return (
                <>
                    <div>
                        <li key={index} id={'progressbar-'+file.name} className={isFailed ? "li-progress failed-file" : "li-progress"}>
                            <div>{file.name}
                              {isFailed
                                ? <span className="red">({failReason} — remove it from the list to continue)</span>
                                : <span id={'error-' + file.name} className="hide red">(File name already exists. Please choose to save as a copy or replace existing file)</span>}
                            </div>
                            < ProgressBar striped variant={isFailed ? "danger" : "success"} id={file.name} now={isFailed ? 100 : 0} />
                        </li>
                        <span className="duplicate-btn">
                          {/* Removing a failed row lets the batch carry on. */}
                          {isFailed && (
                            <span id={'remove-' + file.name} className="btn action-upload-btn" title="Remove"
                                  onClick={() => { props.removeUploadFile && props.removeUploadFile(file) }}>
                                <i className="fa fa-times fa-1x" aria-hidden="true"></i>
                            </span>
                          )}
                          <span id={'replace-' + file.name} className="btn action-upload-btn hide" title="Replace" onClick={()=>{props.duplicateImage('replace',file.name)}}>
                              <i className="fas fa-exchange-alt" aria-hidden="true"></i>
                          </span>
                          <span id={'copy-' + file.name} className="btn action-upload-btn hide" title="Copy" onClick={()=>{props.duplicateImage('copy',file.name)}}>
                              <i className="fa fa-clone fa-1x" aria-hidden="true"></i>
                          </span>
                        </span>
                    </div>
                </>
                );
            })}
        </ul>
    )
}
export default ProgressBarUplaod;